<script setup lang="ts">
import {
  Title,
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@design-system/vue-ui';

export interface PageHeaderBreadcrumb {
  label: string;
  href?: string;
}

defineProps<{
  title: string;
  subtitle?: string;
  breadcrumbs?: PageHeaderBreadcrumb[];
}>();
</script>

<template>
  <header>
    <Breadcrumb v-if="breadcrumbs && breadcrumbs.length">
      <BreadcrumbList>
        <template
          v-for="(crumb, index) in breadcrumbs"
          :key="`${crumb.href ?? crumb.label}-${index}`"
        >
          <BreadcrumbItem>
            <BreadcrumbLink
              v-if="index < breadcrumbs.length - 1 && crumb.href"
              as="a"
              :href="crumb.href"
            >
              {{ crumb.label }}
            </BreadcrumbLink>
            <span v-else-if="index < breadcrumbs.length - 1">{{ crumb.label }}</span>
            <BreadcrumbPage v-else>{{ crumb.label }}</BreadcrumbPage>
          </BreadcrumbItem>
          <BreadcrumbSeparator v-if="index < breadcrumbs.length - 1" />
        </template>
      </BreadcrumbList>
    </Breadcrumb>
    <Title :title="title">
      <!-- cwc-page-header__subtitle is a selector hook ChatView/ConfigureView
           tests already depend on; keep it rather than the description prop. -->
      <template v-if="subtitle" #description>
        <span class="cwc-page-header__subtitle">{{ subtitle }}</span>
      </template>
      <template #actions>
        <slot name="actions" />
      </template>
    </Title>
  </header>
</template>
